import { dataIdCardBack } from 'dls-icons-data'
import { createIcon } from '../common'

const IconIdCardBack = /*#__PURE__*/createIcon(dataIdCardBack)
export default IconIdCardBack
